import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './components/Home';
import JobSeekerAuth from "./components/JobSeekerAuth";
import EmployeeAuth from "./components/EmployeeAuth";
import ModalRegister from './components/ModalRegister';
import Profile from './components/Profile';
import JobSearch from './pagess/JobSearch';
import JobPosting from './components/JobPosting';
import { AuthProvider } from './context/AuthContext';
import ContactUs from './components/ContactUs';
import MVProfile from './components/MVProfile';
import CoursePage from './components/CoursePage';
import CoursesListPage from './components/CoursesListPage';
import AudioCourseAdmin from './pages/AudioCourseAdmin';

import ExcelUploadComponent from './components/CourseManagement';
import VideoCoursesView from './components/VideoCoursesView';
import ArchivedCoursesView from './components/ArchivedCoursesView';
import VideoCourseHomePage from './components/VideoCourseHomePage';
import ManageCoursesPage from './components/ManageCoursesPage';
import SearchResultsPage from './components/SearchResultsPage';
import VideoCourseExcelUpload from './components/VideoCourseExcelUpload';
import VideoCourseVideoUpload from './components/VideoCourseVideoUpload';
import EditCourseOptions from './components/EditCourseOptions'; 

import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/MHMV-profile/jobseeker-login" element={<JobSeekerAuth />} />
            <Route path="/MHMV-profile/employee-login" element={<EmployeeAuth />} />
            <Route path="/MHMV-profile/modal-register" element={<ModalRegister />} />
            <Route path="/MHMV-profile/job-search" element={<JobSearch />} />
            <Route path="/MHMV-profile/job-posting" element={<JobPosting />} />
            <Route path="/MHMV-profile/profile" element={<Profile />} />
            <Route path="/MHMV-profile/my-applications" element={<div className="app-placeholder-page">My Applications Page</div>} />
            <Route path="/MHMV-profile/job/:id" element={<div className="app-placeholder-page">Job Details Page</div>} />
            <Route path="/MHMV-profile/add-profile" element={<div className="app-placeholder-page">Add Profile Page</div>} />
            <Route path="/MHMV-profile/edit-profile" element={<div className="app-placeholder-page">Edit Profile Page</div>} />
            <Route path="/MHMV-profile/mv-agri" element={<div className="app-placeholder-page">MV Agri Page</div>} />
            <Route path="/MHMV-profile/audio-courses" element={<CoursePage courseType="audio" />} />
            <Route path="/MHMV-profile/video-courses" element={<VideoCoursesView />} />
            <Route path="/MHMV-profile/audio-courses/admin" element={<AudioCourseAdmin />} />
            <Route path="/MHMV-profile/upload-course-excel" element={<VideoCourseExcelUpload />} />
          
            <Route path="/MHMV-profile/edit-course-options" element={<EditCourseOptions />} />  
            <Route path="/MHMV-profile/upload-course-videos/:courseId" element={<VideoCourseVideoUpload />} />
            <Route path="/MHMV-profile/courses-list" element={<CoursesListPage />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/mv-profile" element={<MVProfile />} />
            <Route path="/MHMV-profile/video-course-home" element={<VideoCourseHomePage />} />
            <Route path="/MHMV-profile/manage-courses" element={<ManageCoursesPage />} />
            <Route path="/MHMV-profile/archived-courses" element={<ArchivedCoursesView />} />
            <Route path="/MHMV-profile/search-results" element={<SearchResultsPage />} />
            <Route path="/MHMV-profile/upload-courses" element={<ExcelUploadComponent />} />            
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;